<template>
    <v-row justify="end" class="ma-0 pa-0">
        <v-dialog
                v-model="dialog"
                hide-overlay
                width="auto"
                :fullscreen="$vuetify.breakpoint.xsOnly"
                transition="dialog-bottom-transition"
        >
            <v-card style="min-width: 450px" class="card">
                <v-container class="container">
                    <template>
                        <div class="headSection">
                            <div class="centered-child">Export Settings</div>
                            <div class="right-aligned-child" @click="close">X</div>
                        </div>
                        <p class="headText">
                            Select the fields to include in the export file. You can rename them if needed or leave it empty to use the original name
                        </p>
                        <v-data-table
                            :items="items"
                            :headers="fileHeaders"
                            class="elevation-1"
                            :items-per-page="-1"
                            disable-sort
                        >
                            <template v-for="header in fileHeaders" :slot="`item.${[header.value]}`" slot-scope="{item}">
                                <template v-if="header.value === 'include'">
                                    <div class="d-flex justify-center">
                                        <v-checkbox
                                                v-model="item.isInclude"
                                                color="primary"
                                                hide-details
                                        ></v-checkbox>
                                    </div>
                                </template>
                                <template v-else-if="header.value ==='renamed_to'">
                                    <v-text-field
                                            v-model="item.renamed_to"
                                            single-line
                                            hide-details
                                    ></v-text-field>
                                </template>
                                <template v-else>{{item[header['value']]}}</template>
                            </template>
                        </v-data-table>
                    </template>
                    <div class="btn-section">
                        <v-btn @click="download">Download</v-btn>
                    </div>
                </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data: () => ({
            dialog: false,
            items: [],
            fileHeaders: [
                { text: 'Include', value: 'include', align: 'center', width: '10%'},
                { text: 'Column', value: 'column', align: 'center',  width: '25%'},
                { text: 'Renamed To', value: 'renamed_to', align: 'center', width: '25%' },
                { text: 'Preview', value: 'preview', align: 'center', width: '40%' }
            ],
            firstRow: {},
        }),
        props: {
            isShow: Boolean,
            headers: {
                type: Array,
                default: []
            },
            example: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        async mounted() {
            this.dialog = this.isShow;
            this.firstRow = this.getAllAffiliates && this.getAllAffiliates.data
                ? this.getAllAffiliates.data[0]
                : {};
            this.firstRow.verticals = this.firstRow.verticals ? this.firstRow.verticals.map(v => v.name).join(';') : '';
        },
        watch: {
          isShow() {
              this.dialog = !this.dialog
          },
          example(newVal, oldVal) {
              const excludedColumns = ['affNameId', 'actions']
              this.firstRow = { ...newVal };
              if (newVal) {
                this.firstRow = { ...newVal };
                  if (oldVal && newVal.id !== oldVal.id) {
                    this.firstRow = { ...newVal };
                  }
                  this.firstRow.verticals = this.firstRow.verticals ? this.firstRow.verticals.map(v => v.name).join(';') : '';
                  const modifiedHeaders = [...this.headers];
                  modifiedHeaders.push('streetAddress');
                  modifiedHeaders.push('streetAddress2');
                  modifiedHeaders.push('city');
                  modifiedHeaders.push('state');
                  modifiedHeaders.push('postalCode');
                  modifiedHeaders.push('country');
                  this.items.length = 0;
                  modifiedHeaders.unshift('id');
                  modifiedHeaders.unshift('name');
                  modifiedHeaders.filter(mh => !excludedColumns.includes(mh)).forEach(h => {
                      const item = {
                          isInclude: true,
                          column: h,
                          renamed_to: '',
                          preview:  this.firstRow[h]
                      };
                      this.items.push(item);
                  });
              }
          },
        },
        computed: {
            ...mapGetters('affiliates', ['getAllAffiliates'])
        },
        methods:{
            download() {
              if (!this.getAllAffiliates || !this.getAllAffiliates.data) {
                  return;
              }
              const dataItems = [...this.getAllAffiliates.data];
              let csvHeaderArray = this.items.reduce((acc, cur) => {
                  if (cur.isInclude) {
                      acc.push(cur.renamed_to || cur.column);
                  }
                  return acc;
              }, []);

              let csvBody = '';
              let csvBodyArray = [];
               const addressFields = ['streetAddress', 'streetAddress2', 'city', 'state', 'postalCode', 'country'];
              
              // Функция для экранирования значений CSV
              const escapeCSV = (value) => {
                  if (value === null || value === undefined) return '';
                  const strValue = value.toString();
                  // Если содержит запятую, кавычки или перенос строки - оборачиваем в кавычки
                  if (strValue.includes(',') || strValue.includes('"') || strValue.includes('\n')) {
                      // Экранируем кавычки удвоением
                      return `"${strValue.replace(/"/g, '""')}"`;
                  }
                  return strValue;
              };
              
              for (let i = 0; i < dataItems.length; i++) {
                for (let j = 0; j < this.items.length; j++) {
                    if (this.items[j]['isInclude']) {
                        const columnName = this.items[j]['column'];
                        
                        if (columnName === 'verticals') {
                            const data = dataItems[i][columnName].length !== 0
                                ? dataItems[i][columnName].map(v => v.name).join(';')
                                : '';
                            csvBodyArray.push(escapeCSV(data));
                        } else if (addressFields.includes(columnName)) {
                            const value = dataItems[i][columnName] || 'N/A';
                            csvBodyArray.push(escapeCSV(value));
                        } else {
                            csvBodyArray.push(escapeCSV(dataItems[i][columnName]));
                        }
                    }
                }
                csvBody += csvBodyArray.join(',') + '\n';
                csvBodyArray.length = 0;
              }

              const csv = csvHeaderArray.join(',') + '\n' + csvBody;
              const blob = new Blob([csv], { type: "text/csv" });

              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "affiliates.csv";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            },

            startCase() {
                this.dialog = true;
            },

            close() {
                this.dialog = false;
            },
        }
    }
</script>

<style scoped lang="sass">
    .v-input
        padding: 0 !important
    .btn-section
        text-align: end
        margin: 2%
    .v-btn
        text-transform: capitalize !important
        min-width: 450px
    .v-btn__content
        color: black
    .container
        background-color: #f5f5f5
        padding: 0
    .theme--light.v-data-table
        background-color: #f5f5f5 !important
        padding-left: 5%
        padding-right: 5%
    .headText
        margin-top: 3%
        padding-left: 10%
        padding-right: 10%
        text-align: center
    .headSection
        padding-top: 2%
        display: flex
        justify-content: space-between
        align-items: center
    .centered-child
        margin-left: 40%
        font-weight: bold
        font-size: 16pt
        color: #3a3852

    .right-aligned-child
        font-weight: bold
        margin-left: auto
        font-size: 16pt
        margin-right: 3%
        &:hover
            cursor: pointer
</style>
